import React from 'react';

const Feedback = ({ message }) => (
  <div className='feedback'>
    <p>{message}</p>
  </div>
);

export default Feedback;